import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // ✅ Font Awesome icons

export default function Booking({
  cards = [
  {
    title: "13 Seater Tempo Traveller",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹3,499",
    seater: "13 Seater",
    perKm: "₹23 / Km",
    extraHr: "₹180 / Hr",
    image: "/images/gallery/1.jpg",
  },
  {
    title: "17 Seater Tempo Traveller",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹4,499",
    seater: "17 Seater",
    perKm: "₹25 / Km",
    extraHr: "₹200 / Hr",
    image: "/images/gallery/2.jpg",
  },
  {
    title: "Luxury Force Urbania",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹4,999",
    seater: "17 Seater Luxury Urbania",
    perKm: "₹28 / Km",
    extraHr: "₹250 / Hr",
    image: "/images/gallery/3.jpg",
  },
  {
    title: "32 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹6,499",
    seater: "32 Seater AC Bus",
    perKm: "₹38 / Km",
    extraHr: "₹300 / Hr",
    image: "/images/gallery/4.jpg",
  },
  {
    title: "35 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹6,999",
    seater: "35 Seater AC Coach",
    perKm: "₹40 / Km",
    extraHr: "₹320 / Hr",
    image: "/images/gallery/5.jpg",
  },
  {
    title: "40 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹7,499",
    seater: "40 Seater Luxury Bus",
    perKm: "₹42 / Km",
    extraHr: "₹350 / Hr",
    image: "/images/gallery/6.jpg",
  },
  {
    title: "45 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹7,999",
    seater: "45 Seater AC Coach",
    perKm: "₹44 / Km",
    extraHr: "₹380 / Hr",
    image: "/images/gallery/7.jpg",
  },
  {
    title: "50 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹8,499",
    seater: "50 Seater Volvo Bus",
    perKm: "₹46 / Km",
    extraHr: "₹400 / Hr",
    image: "/images/gallery/8.jpg",
  },
  {
    title: "AC Luxury Bus",
    company: "Amruta Travels Pvt Ltd",
    priceLabel: "Starting ₹8,999",
    seater: "53 Seater Volvo / BharatBenz",
    perKm: "₹48 / Km",
    extraHr: "₹450 / Hr",
    image: "/images/gallery/9.jpg",
  },
]
}) {
  const handleWhatsAppBooking = (title) => {
    const phone = "918010014995"; // Your WhatsApp number (with country code, no + sign)
    const message = `Hello Amruta Travels, I want to book ${title}. Please share more details.`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* ===== Page Header ===== */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content text-center">
            <h2 className="page-header__title">Booking</h2>
          </div>
        </div>
      </section>

      {/* ===== Booking Cards ===== */}
      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => (
              <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                <div
                  className="taxi-card d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s ease",
                    height: "100%",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-6px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  {/* Top Image Section */}
                  <div
                    className="taxi-card__image"
                    style={{
                      backgroundColor: "#0072bc",
                      padding: "20px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  </div>

                  {/* Card Content */}
                  <div
                    className="taxi-card__content d-flex flex-column justify-content-between"
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "25px 20px",
                      flex: "1",
                    }}
                  >
                    {/* Title */}
                    <div>
                      <h3 className="taxi-card__title mb-2 text-center">
                        {c.title}
                      </h3>
                      <p
                        className="taxi-card__company mb-4 text-center"
                        style={{ color: "#b0b0b0", fontSize: "0.9rem" }}
                      >
                        {c.company}
                      </p>

                      {/* Centered Details */}
                      <ul
                        className="taxi-card__list list-unstyled"
                        style={{
                          margin: "0 auto 25px auto",
                          textAlign: "center",
                          color: "#fff",
                          fontSize: "0.95rem",
                          width: "80%",
                        }}
                      >
                        <li className="d-flex justify-content-between mb-2">
                          <span>Seater:</span> <span>{c.seater}</span>
                        </li>
                        <li className="d-flex justify-content-between mb-2">
                          <span>Per Km:</span> <span>{c.perKm}</span>
                        </li>
                        <li className="d-flex justify-content-between">
                          <span>Extra Hr:</span> <span>{c.extraHr}</span>
                        </li>
                      </ul>
                    </div>

                    {/* Book Now Button */}
                    <div className="text-center mt-auto">
                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#0072bc",
                          color: "#fff",
                          borderRadius: "6px",
                          padding: "10px 24px",
                          fontWeight: 600,
                          textDecoration: "none",
                          gap: "8px",
                          width: "60%",
                          border: "none",
                          cursor: "pointer",
                          transition: "background 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#005fa3")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#0072bc")
                        }
                      >
                        <i className="fab fa-whatsapp" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
